// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/cockpit-controls.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/cockpit-controls/cockpit-controls.js';

mount([g0]);
